import { addMinutes as addMinutesDate, differenceInMinutes, format, parse } from 'date-fns';
import { ISelectOption } from '../../InputSelect';

/**
 * Calculate duration between two times in minutes
 */
export const calculateDurationInMinutes = (arrival: string, departure: string): number => {
  const timeFormat = 'hh:mm aaa';
  const referenceDate = new Date(2000, 0, 1);
  const tArrival = parse(arrival, timeFormat, referenceDate);
  const tDeparture = parse(departure, timeFormat, referenceDate);
  return differenceInMinutes(tDeparture, tArrival);
};

/**
 * Format duration as "Xh YYm" (hide minutes if 0)
 */
export const formatDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  if (mins === 0) {
    return `${hours}h`;
  }
  return `${hours}h ${mins}m`;
};

/**
 * Add minutes to a time string
 */
export const addMinutesToTime = (time: string, minutes: number): string => {
  const timeFormat = 'hh:mm aaa';
  const referenceDate = new Date(2000, 0, 1);
  const timeParsed = parse(time, timeFormat, referenceDate);
  const result = addMinutesDate(timeParsed, minutes);
  return format(result, timeFormat);
};

/**
 * Format time limit for error message (e.g., "4-hour" from 240 minutes)
 */
export const formatTimeLimit = (minutes: number): string => {
  const hours = minutes / 60;
  return `${hours}-hour`;
};

export const factoryTimeOptions = (): ISelectOption[] => {
  const opts: ISelectOption[] = [];

  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += 15) {
      let formattedHour;
      if (hour === 0) {
        formattedHour = 12;
      } else if (hour > 12) {
        formattedHour = hour - 12;
      } else {
        formattedHour = hour;
      }

      const ampm = hour < 12 ? 'am' : 'pm';
      const formattedHourPadded = formattedHour.toString().padStart(2, '0');
      const formattedMinute = minute.toString().padStart(2, '0');
      const title = `${formattedHourPadded}:${formattedMinute} ${ampm}`;

      opts.push({ title, value: title });
    }
  }

  return opts;
};
